import { Tooltip } from '@/shared/images/icons/Tooltip';
import { memo, useState, useEffect } from 'react';
import * as S from './LoadingMessage.styles';

type TMessage = {
    title: string;
    subtitle: string;
    description: string;
};

function* Messages(): Generator<TMessage> {
    yield {
        title: 'Processing',
        subtitle: 'Thank you for your patience',
        description: 'Please be patient, do not leave this page.',
    };
    yield {
        title: 'Still Processing',
        subtitle: 'Wait for a status',
        description:
            "Please stay on this page and wait for confirmation. We're sorry for the delay.",
    };
    return {
        title: 'Sorry for the delay',
        subtitle: 'Almost there',
        description:
            'We will have an order status for you shortly. Please continue to stay on this page.',
    };
}

const SECONDS = 15_000;

const LoadingMessageContainer = () => {
    const [message, setMessage] = useState({
        title: 'Processing your order',
        subtitle: 'This can take up to a minute',
        description:
            'We are currently processing your order. Please be patient and do not leave this page. Order can take as long as 60 seconds to be secured.',
    });

    useEffect(() => {
        const getMessage = Messages();

        const timerID = setInterval(() => {
            const newMessage = getMessage.next();
            setMessage(newMessage.value);

            if (newMessage.done) {
                clearInterval(timerID);
            }
        }, SECONDS);

        return () => clearInterval(timerID);
    }, []);

    return (
        <S.Wrapper>
            <Tooltip />
            <div>
                <S.Title>{message.title}</S.Title>
                {message.subtitle}
                <br />
                {message.description}
            </div>
        </S.Wrapper>
    );
};

export const LoadingMessage = memo(LoadingMessageContainer);
